var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "programming" },
    [
      _c(
        "div",
        {
          ref: "programming_left",
          staticClass: "programming_left",
          style: _vm.leftDivStyle
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("span", {
              staticClass: "el-icon-back",
              on: { click: _vm.goBack }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.resourceName))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottomer" }, [
            _c("div", { staticClass: "nava" }, [
              _c("div", { staticClass: "nava_tool" }, [
                _c(
                  "p",
                  {
                    class: { activeP: _vm.toolTab === 0 },
                    on: {
                      click: function($event) {
                        return _vm.nava_tool_click(0)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "el-icon-tickets",
                      staticStyle: { "font-size": "22px" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "nava_label" }, [_vm._v("步骤")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    class: { activeP: _vm.toolTab === 1 },
                    on: {
                      click: function($event) {
                        return _vm.nava_tool_click(1)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "el-icon-tickets",
                      staticStyle: { "font-size": "22px" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "nava_label" }, [_vm._v("评分")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    class: { activeP: _vm.toolTab === 2 },
                    on: {
                      click: function($event) {
                        return _vm.nava_tool_click(2)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "el-icon-notebook-1",
                      staticStyle: { "font-size": "22px" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "nava_label" }, [_vm._v("笔记")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nava_menu",
                  class: { activeNava: _vm.toolTab === 0 }
                },
                [
                  _c(
                    "div",
                    { staticClass: "nava_menu_style" },
                    _vm._l(_vm.treeData, function(item, index) {
                      return _c(
                        "p",
                        {
                          key: index,
                          class: { activeRound: _vm.activeIndex == index },
                          on: {
                            click: function($event) {
                              return _vm.activeThisOne(item, index)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "item_round",
                              class: {
                                item_activeRound: _vm.activeIndex == index
                              }
                            },
                            [_vm._v(_vm._s(index + 1))]
                          ),
                          _c("span", [_vm._v(_vm._s(item.name))])
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nava_menu",
                  class: { activeNava: _vm.toolTab === 1 }
                },
                [
                  _vm.stepWeight
                    ? _c(
                        "div",
                        { staticClass: "rateBox" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-right": "10px",
                                "font-size": "12px"
                              }
                            },
                            [_vm._v("得分:")]
                          ),
                          _vm._v(" "),
                          _c("el-rate", {
                            attrs: {
                              disabled: "",
                              "show-score": "",
                              "text-color": "#ff9900",
                              "score-template": "{value}"
                            },
                            model: {
                              value: _vm.stepWeight,
                              callback: function($$v) {
                                _vm.stepWeight = $$v
                              },
                              expression: "stepWeight"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nava_menu_style" },
                    [
                      _vm._l(_vm.treeData, function(item, index) {
                        return [
                          item.itData
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  class: {
                                    activeRound: _vm.activeIndex == index
                                  }
                                },
                                [
                                  _c(
                                    "el-collapse",
                                    {
                                      model: {
                                        value: _vm.activeNames,
                                        callback: function($$v) {
                                          _vm.activeNames = $$v
                                        },
                                        expression: "activeNames"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-collapse-item",
                                        { attrs: { name: index } },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _c(
                                              "span",
                                              { staticClass: "item_round" },
                                              [_vm._v(_vm._s(index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(item.name))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(item.itData, function(
                                            ititem,
                                            itindex
                                          ) {
                                            return _c(
                                              "div",
                                              { key: itindex + "a" },
                                              _vm._l(
                                                ititem.agreementList,
                                                function(aitem, aindex) {
                                                  return _c(
                                                    "p",
                                                    {
                                                      key: aindex + "b",
                                                      staticClass: "agreementP",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.activeThisOne(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "yuanqiu"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(aindex + 1)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(aitem.title)
                                                          )
                                                        ])
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        aitem.unitWeight
                                                          ? _c("span", {
                                                              staticClass:
                                                                "el-icon-success",
                                                              staticStyle: {
                                                                color: "#67C23A"
                                                              }
                                                            })
                                                          : _c("span", {
                                                              staticClass:
                                                                "el-icon-error",
                                                              staticStyle: {
                                                                color: "#F56C6C"
                                                              }
                                                            })
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nava_note",
                  class: { activeNava: _vm.toolTab === 2 }
                },
                [_c("Note", { ref: "programming_note" })],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "content"
              },
              [
                _c("div", { staticClass: "content_header activeRound" }, [
                  _c("span", { staticClass: "item_activeRound" }, [
                    _vm._v(_vm._s(_vm.activeIndex + 1))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "item_label" }, [
                    _vm._v(_vm._s(_vm.activeOne.name || "前序"))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_content" },
                  _vm._l(_vm.activeOne.imageText, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "type6Item" },
                      [
                        item
                          ? [
                              item.type === 1
                                ? _c("div", {
                                    staticClass: "ql-editor",
                                    domProps: { innerHTML: _vm._s(item.value) }
                                  })
                                : item.type === 3
                                ? _c("questionRender", {
                                    attrs: {
                                      question: item,
                                      questionAnswer: item.questionAnswer
                                    }
                                  })
                                : item.type === 7
                                ? _c("el-image", {
                                    staticClass: "type6resouce",
                                    style: {
                                      width: item.styleOption.width
                                        ? item.styleOption.width + "%"
                                        : "50%"
                                    },
                                    attrs: {
                                      src: item.value,
                                      "preview-src-list": [item.value]
                                    }
                                  })
                                : item.type === 10
                                ? _c(
                                    "video",
                                    {
                                      staticClass: "video-js type6resouce",
                                      style: {
                                        width: item.styleOption.width + "%"
                                      },
                                      attrs: {
                                        controls: "",
                                        preload: "auto",
                                        controlslist: "nodownload",
                                        "data-setup": "{'example_option':true}"
                                      }
                                    },
                                    [
                                      _c("source", {
                                        staticClass: "video",
                                        attrs: {
                                          src: item.value,
                                          type: "video/mp4"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "vjs-no-js" }, [
                                        _vm._v("不支持播放")
                                      ])
                                    ]
                                  )
                                : item.type === 11
                                ? _c("code-compiler", {
                                    ref: "codeCompiler",
                                    refInFor: true,
                                    attrs: {
                                      readPage: true,
                                      readOnly: "",
                                      refresh: item.value
                                    },
                                    model: {
                                      value: item.value,
                                      callback: function($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value"
                                    }
                                  })
                                : item.type === 12
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            trigger: "click"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "zl_button zl_blueButton",
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleImport(
                                                    item.value
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("下 载")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "reference",
                                                size: "mini"
                                              },
                                              slot: "reference"
                                            },
                                            [_vm._v(_vm._s(item.value))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.activeOne.rightNumber || _vm.activeOne.errorNumber
                  ? _c("div", { staticClass: "eventScoring" }, [
                      _c(
                        "div",
                        {
                          staticClass: "eventScoringL",
                          on: { click: _vm.openEventScoring }
                        },
                        [
                          _vm.eventScoring
                            ? _c("span", { staticClass: "el-icon-arrow-down" })
                            : _c("span", { staticClass: "el-icon-arrow-up" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "eventScoringContent",
                          class: { eventScoringShow: _vm.eventScoring }
                        },
                        [
                          _c("div", { staticClass: "eventScoringHead" }, [
                            _c(
                              "span",
                              { staticClass: "eventScoringHeadItem" },
                              [
                                _c("span", {
                                  staticClass: "el-icon-success",
                                  staticStyle: { color: "#67C23A" }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "eventScoringHeadNumber" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.activeOne.rightNumber || 0)
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "eventScoringHeadItem" },
                              [
                                _c("span", {
                                  staticClass: "el-icon-error",
                                  staticStyle: { color: "#F56C6C" }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "eventScoringHeadNumber" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.activeOne.errorNumber || 0)
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "eventScoringHeadItem" },
                              [
                                _c("span", {
                                  staticClass: "el-icon-menu",
                                  staticStyle: { color: "#999999" }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "eventScoringHeadNumber" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.activeOne.rightNumber +
                                            _vm.activeOne.errorNumber || 0
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(_vm.activeOne.itData, function(
                              ititem,
                              itindex
                            ) {
                              return _c(
                                "div",
                                { key: itindex + "a" },
                                _vm._l(ititem.agreementList, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "p",
                                    {
                                      key: index + "b",
                                      staticClass: "agreementP"
                                    },
                                    [
                                      _c("span", [
                                        _c("span", { staticClass: "yuanqiu" }, [
                                          _vm._v(_vm._s(index + 1))
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(_vm._s(item.title))])
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        item.unitWeight
                                          ? _c("span", {
                                              staticClass: "el-icon-success",
                                              staticStyle: { color: "#67C23A" }
                                            })
                                          : _c("span", {
                                              staticClass: "el-icon-error",
                                              staticStyle: { color: "#F56C6C" }
                                            })
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "content_footer" }, [
                  _vm.activeIndex > 0
                    ? _c(
                        "span",
                        {
                          staticClass: "courseSubBtn zl_button zl_whiteButton",
                          on: { click: _vm.prev }
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "courseSubBtn zl_button zl_blueButton",
                      staticStyle: { margin: "0 20px" },
                      on: { click: _vm.postMessage }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.treeData.length == 1 || _vm.isEnd
                              ? "测评"
                              : _vm.activeOne.errorNumber
                              ? "重新测评"
                              : "下一步"
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.activeOne.errorNumber && !_vm.isEnd
                    ? _c(
                        "span",
                        { staticClass: "skip", on: { click: _vm.next } },
                        [_vm._v("跳过")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEnd
                    ? _c(
                        "span",
                        {
                          staticClass: "nextSection",
                          on: { click: _vm.nextSection }
                        },
                        [_vm._v("\n            学习下一节\n          ")]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.toolTab >= 0
              ? _c("div", {
                  staticClass: "bottomerMask",
                  on: {
                    click: function($event) {
                      _vm.toolTab = -1
                    }
                  }
                })
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "programming_line",
          on: {
            mousedown: function($event) {
              $event.stopPropagation()
              return _vm.lineMove($event)
            }
          }
        },
        [
          _c("span", { staticClass: "code_line_icon" }, [
            _c(
              "svg",
              {
                staticClass: "icon svg-icon",
                staticStyle: { width: "20px", height: "13px" },
                attrs: { "aria-hidden": "true" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-tuozhuai1" } })]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "programming_right" },
        [
          _vm.showRightType === 0
            ? _c("code-compiler", {
                ref: "taskCode",
                staticStyle: { width: "100%", height: "100%" },
                attrs: { task: "", refresh: _vm.refresh },
                model: {
                  value: _vm.taskData,
                  callback: function($$v) {
                    _vm.taskData = $$v
                  },
                  expression: "taskData"
                }
              })
            : _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    position: "relative"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "toolsSet" },
                    [
                      _vm.showjuPyterTools
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: "设置",
                                placement: "left-start"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-s-tools",
                                on: {
                                  click: function($event) {
                                    _vm.showjuPyterTools = false
                                  }
                                }
                              })
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "toolsShowStyle" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: "收起",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-setting",
                                    on: {
                                      click: function($event) {
                                        _vm.showjuPyterTools = true
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: _vm.timeout
                                      ? "请" + _vm.timeout + "秒后再重置"
                                      : "重置数据",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-refresh",
                                    style: {
                                      cursor: _vm.timeout
                                        ? "not-allowed"
                                        : "pointer"
                                    },
                                    on: { click: _vm.jupyterReset }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: _vm.timeout
                                      ? "请" + _vm.timeout + "秒后再重启"
                                      : "重启环境",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-video-play",
                                    style: {
                                      cursor: _vm.timeout
                                        ? "not-allowed"
                                        : "pointer"
                                    },
                                    on: { click: _vm.jupyterRestart }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("it-loading", { ref: "itLoading" }),
                  _vm._v(" "),
                  _c("iframe", {
                    ref: "OSiframe",
                    staticStyle: { position: "absolute" },
                    attrs: {
                      height: "100%",
                      width: "100%",
                      src: _vm.iframeAddress,
                      frameborder: "0"
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c("zl-rate", {
        attrs: { refresh: _vm.rateRefresh },
        model: {
          value: _vm.stepWeight,
          callback: function($$v) {
            _vm.stepWeight = $$v
          },
          expression: "stepWeight"
        }
      }),
      _vm._v(" "),
      _c("temporary-interaction", {
        attrs: {
          "common-data": _vm.getInteractionData(),
          "user-type": _vm.userType,
          showToolsBox: _vm.showToolsBox
        }
      }),
      _vm._v(" "),
      _c("office-re-edit", {
        attrs: {
          showToolsBox: _vm.showToolsBox && String(_vm.userType) !== "2",
          "page-tools": {
            show:
              _vm.activeOne.szrtType == 1 ||
              _vm.activeOne.szrtType == 2 ||
              _vm.activeOne.szrtType == 8
          },
          "upload-file-data": _vm.getUploadFileData()
        },
        on: { prev: _vm.prev, next: _vm.next, openSide: _vm.openSide }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59c32c03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c32c03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/Learning_details/programming.vue
// module id = null
// module chunks = 